import React from 'react';

interface ShowProps {
  when: boolean | undefined | null | string | number;
  children: React.ReactNode
}

export default function Show({ when, children }: ShowProps) {
  if (when) {
    return <>{children}</>;
  }
  return null;
}
